"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GetBucketAclInput_1 = require("./GetBucketAclInput");
var GetBucketAclOutput_1 = require("./GetBucketAclOutput");
var ServiceMetadata_1 = require("./ServiceMetadata");
exports.GetBucketAcl = {
    metadata: ServiceMetadata_1.ServiceMetadata,
    name: "GetBucketAcl",
    http: {
        method: "GET",
        requestUri: "/{Bucket}?acl"
    },
    input: {
        shape: GetBucketAclInput_1.GetBucketAclInput
    },
    output: {
        shape: GetBucketAclOutput_1.GetBucketAclOutput
    },
    errors: []
};
//# sourceMappingURL=GetBucketAcl.js.map